import { inject, Injectable } from '@angular/core';
import { SquareDeviceTypeEndpoints } from 'app/core/enums/endpoints/gateway.enum';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';
import { SquareDeviceTypePayload } from '../../types';

@Injectable({
    providedIn: 'root',
})
export class SquareDeviceTypeService {
    private _endpoint = SquareDeviceTypeEndpoints;
    private _apiService = inject(ApiService);

    constructor() {}

    // ------------------------------------------------------------------
    // @ CRUD methods
    // ------------------------------------------------------------------

    getAll(): Observable<any> {
        return this._apiService.get(this._endpoint.getAll);
    }

    getOne(id: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getOne, id);
    }

    create(data: SquareDeviceTypePayload): Observable<any> {
        return this._apiService.post(this._endpoint.create, data);
    }

    update(data: string, id: number): Observable<any> {
        return this._apiService.update(this._endpoint.update, data, id);
    }

    delete(id: number): Observable<any> {
        return this._apiService.delete(this._endpoint.delete, id);
    }
}
